import styled from 'styled-components';
import { IconContainerProps } from '..';

export const IconContainerWrapper = styled.i<IconContainerProps>`
  display: inline-block;
  height: ${({ theme, size }) => theme.Button.sizes[size].fontSize};
  max-width: calc((${({ theme, size }) => theme.Button.sizes[size].fontSize}) * 2);

  svg,
  img {
    height: 100%;
    fill: ${({ theme, active }) => (active ? theme.Rating.default.color : theme.Rating.disabled.color)};
  }
`;
